export default __webpack_public_path__ + "static/media/enFlag.7bb03f7e.svg";